"use client";

import { ReactNode } from "react";
import { Typography } from "../typography";
import { X } from "lucide-react";
import { Button } from "../buttons/button";
import { cn } from "@drpcrd/utils/shared";

export type ChatContextMenuBarProps = {
  agentName?: string;
  onClose: () => void;
  actions?: ReactNode;
};

export const ChatContextMenuBar = ({
  agentName,
  onClose,
  actions,
}: ChatContextMenuBarProps) => (
  <nav
    role="navigation"
    aria-label="Chat context menu"
    className={cn(
      "border-border flex items-center justify-between border-b bg-transparent px-3 py-1.5",
    )}
  >
    <div className="min-w-0 flex-1">
      {agentName && (
        <Typography size="sm" weight="semibold" className="min-w-0 truncate">
          {agentName}
        </Typography>
      )}
    </div>

    <div className="flex items-center gap-2">
      {actions && actions}

      <Button
        onClick={onClose}
        aria-label="Close and reset chat"
        variant="text"
        size="md"
        icon={X}
        iconClassName="h-4 w-4"
      />
    </div>
  </nav>
);
